export const SecurityGroupsActionType = {
    REQUEST_SECURITY_GROUPS: 'securityGroups/REQUEST_SECURITY_GROUPS',
    RECEIVE_SECURITY_GROUPS: 'securityGroups/RECEIVE_SECURITY_GROUPS',
    ERROR_SECURITY_GROUPS: 'securityGroups/ERROR_SECURITY_GROUPS',
} as const;

export type SecurityGroupsAction =
    | IRequestSecurityGroupsAction
    | IReceiveSecurityGroupsAction
    | ISecurityGroupsErrorAction;

export interface IRequestSecurityGroupsAction {
    type: typeof SecurityGroupsActionType.REQUEST_SECURITY_GROUPS;
}

export interface IReceiveSecurityGroupsAction {
    type: typeof SecurityGroupsActionType.RECEIVE_SECURITY_GROUPS;
    groups: string[];
}

export interface ISecurityGroupsErrorAction {
    type: typeof SecurityGroupsActionType.ERROR_SECURITY_GROUPS;
    errorMessage?: string;
}
